import React from "react"
import { Suspense } from "react"
import ReactDOM from "react-dom"
import "./index.css"
import "./fonts/bebas_neue_bold.otf"
import MainContent from "./MainContent"

ReactDOM.render(
    <React.StrictMode>
        <Suspense
            fallback={
                <div className="fullcontainer">
                    <div className="center">Loading christmas fun...</div>
                </div>
            }
        >
            <MainContent />
        </Suspense>
    </React.StrictMode>,
    document.getElementById("root")
)
